import { forwardRef, type ReactNode } from 'react';

interface OverlayPanelProps {
  children: ReactNode;
  className?: string;
  zIndexVar?: string;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  ariaDescribedBy?: string;
}

export const OverlayPanel = forwardRef<HTMLDivElement, OverlayPanelProps>(
  function OverlayPanel(
    {
      children,
      className = '',
      zIndexVar = '--z-modal',
      ariaLabel,
      ariaLabelledBy,
      ariaDescribedBy,
    },
    ref,
  ) {
    return (
      <div
        ref={ref}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        aria-describedby={ariaDescribedBy}
        tabIndex={-1}
        className={`pt-safe pb-safe ${className}`}
        style={{ zIndex: `var(${zIndexVar})` }}
      >
        {children}
      </div>
    );
  },
);
